import { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogContent, DialogTitle, Tooltip, AlertColor, Box } from '@mui/material';
import { fontSize, palette } from '../..';
import FetchData from '../ServerCall/FetchData';
import { PopUpSpinner } from '../CommonFunctions/DialogComponents';
import moment from 'moment';
import LinkItem from './LinkItem';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import '../allPages.css';
import './SharedLinks.css';
import CloseIcon from '@mui/icons-material/Close';

function SharedLinks({ token, playBookId, showPopup, handleCloseButtonClick, tabState }: any) {
  const [loading, setLoading] = useState<boolean>(false);
  const [sharedLinks, setSharedLinks] = useState<any>([]);
  const [openAlertPopup, setOpenAlertPopup] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedLinkId, setSelectedLinkId] = useState(null);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>('');
  const [severity, setSeverity] = useState<AlertColor>('success');

  /** Memoised list of tab options from Redux tabState (raw tab names, no slugification) */
  const tabOptions = useMemo(() => {
    if (!tabState?.tabList) return [];
    return tabState.tabList
      .filter((tabId: number) => !tabState.tabs[tabId]?.hidden)
      .map((tabId: number) => ({
        tabId,
        tabName: tabState.tabs[tabId]?.tabName || `Tab ${tabId}`,
      }));
  }, [tabState?.tabList, tabState?.tabs]);

  const showAlert = (message: string, severity: AlertColor) => {
    setTestMessage(message);
    setSeverity(severity);
    setOpenAlert(true);
    setTimeout(() => {
      setOpenAlert(false);
    }, 3000);
  };

  useEffect(() => {
    if (playBookId) {
      getAllLinks();
    } else {
      setLoading(false);
      setOpenAlertPopup(true);
      setErrorMessage('Please save the playbook before sharing it.');
    }
  }, []);

  const createNewLink = async () => {
    //playbook/open-link/{}?expiryDate=2025-02-24
    try {
      if (sharedLinks.length < 3) {
        setLoading(true);
        var result = await FetchData({
          requestType: 'noData',
          method: 'POST',
          url: `playbook/open-link/${playBookId}?expiryDate=${moment(new Date()).add(90, 'd').format('YYYY-MM-DD')}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (result.status) {
          getAllLinks();
        } else setLoading(false);
      } else {
        setOpenAlertPopup(true);
        setErrorMessage('Cannot create more than 3 links for this playbook');
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const getAllLinks = async () => {
    ///playbook/open-links/{playBookId}
    try {
      setLoading(true);
      var result = await FetchData({
        requestType: 'noData',
        method: 'GET',
        url: `playbook/open-links/${playBookId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (result.status) {
        const sortedLinks = result.data.sort((a: any, b: any) => a.linkId.localeCompare(b.linkId));

        setSharedLinks(sortedLinks);
        setLoading(false);
      } else setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleDeleteClick = useCallback((linkId: any) => {
    setSelectedLinkId(linkId);
    setOpenDeleteDialog(true);
  }, []);

  const confirmDeleteLink = async (linkId: string) => {
    //playbook/open-link/2e8f8c0d-b723-49f9-90e5-09672fb2d308
    if (!linkId) return;
    try {
      setLoading(true);
      setOpenDeleteDialog(false);
      var result = await FetchData({
        requestType: 'noData',
        method: 'DELETE',
        url: `playbook/open-link/${linkId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (result.status) {
        getAllLinks();
      } else setLoading(false);

      if (!result.status) {
        setOpenAlertPopup(true);
        setErrorMessage('Something went wrong. Failed to delete the link.');
      }

      setSelectedLinkId(null);
    } catch (err) {
      setLoading(false);
      // console.error(err);
    }
  };

  const updateLink = useCallback(
    async (linkId: string, expirationDate: any) => {
      ///playbook/open-link/7ba79fdb-9671-4602-ad17-7dc64cab18a3?expiryDate=2025-02-04

      try {
        setLoading(true);
        var result = await FetchData({
          requestType: 'noData',
          method: 'PUT',
          url: `playbook/open-link/${linkId}?expiryDate=${moment(expirationDate).format('YYYY-MM-DD')}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (result.status) {
          setLoading(false);
          showAlert('Link is updated successfully.', 'success');
        } else {
          setLoading(false);
          const errorMsg = result?.error || 'Failed to update link.';
          showAlert(errorMsg, 'error');
          throw new Error(errorMsg);
        }
      } catch (err) {
        setLoading(false);
        

        showAlert(err instanceof Error?err.message : 'An error occurred while updating the link.', 'error');
        throw err;
      }
    },
    [token],
  );

  return (
    <div>
      {errorMessage?.length > 0 ? (
        <NotificationDialog
          onCloseAlert={() => {
            setOpenAlertPopup(false);
            setErrorMessage('');
          }}
          severity={'error'}
          testMessage={errorMessage}
          openAlert={openAlertPopup}
        />
      ) : null}
      <Dialog
        id="basic-menu"
        className="geoHelpTable"
        open={showPopup}
        PaperProps={{
          sx: {
            minHeight: '20%',
            width: '55rem',
            // maxWidth: "30rem",
            border: '1px solid transparent',
          },
        }}
      >
        <div className="shared-links-header-close-container">
          {/* <CloseOutlined
              onClick={handleCloseButtonClick}
              style={{ float: "right", color: "red", alignSelf: "center" }}/> */}
          <div className="expire-link-close">
            <Tooltip
              title="Close"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <CloseIcon
                onClick={handleCloseButtonClick}
                sx={{
                  fontSize: 'large',
                  color: '#545454',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'red',
                  },
                }}
              />
            </Tooltip>
          </div>

          <div style={{ textAlign: 'center', width: '100%', marginTop: '20px' }}>
            <DialogTitle
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <h2>Share Dashboard</h2>&nbsp;
              <img
                key={'Share'}
                // className={"controlsIcon"}
                style={{
                  height: '26px',
                  width: '26px',
                  padding: '0.2rem',
                }}
                src={'/share.png'}
                alt={'Share Playbook'}
              />
            </DialogTitle>
          </div>
        </div>

        <DialogContent
          sx={{
            width: '100%',
            // height: "25rem",
            // overflowY: "auto",
            // paddingRight: "0.6rem",
            // display: "flex",
            // flexDirection: "column",
            border: '1px solid transparent',
          }}
        >
          <Tooltip
            title="Create a new link to share the playbook"
            slotProps={{ tooltip: { sx: { fontSize: fontSize.medium } } }}
            placement="top"
            arrow
          >
            <button
              className="create-workspace"
              style={{
                fontSize: fontSize.medium,
                color: palette.primary.main,
                width: '5rem',
                marginBottom: '5px',
              }}
              onClick={createNewLink}
            >
              <img
                src="/add_green.png"
                alt="Add Link"
                style={{ width: '16px', height: '16px', marginLeft: '-2px' }}
              />
              &nbsp;New
            </button>
          </Tooltip>

          <div className="link-expire-date-copy-container" style={{ width: '100%' }}>
            {sharedLinks.length > 0 ? (
              sharedLinks.map((link: any, index: number) => (
                <LinkItem
                  key={link.linkId}
                  link={link}
                  index={index}
                  onUpdate={updateLink}
                  onDelete={handleDeleteClick}
                  tabOptions={tabOptions}
                />
              ))
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  height: '100%',
                  width: '100%',
                  lineHeight: '0.75rem',
                  pt: '0.75rem',
                }}
              >
                <div className="no-links-container" style={{ fontSize: 'small' }}>
                  <p>No saved links found.</p>
                  <p>You can create one or more links to share the playbook.</p>
                </div>
              </Box>
            )}
          </div>

          {/* <SnackBar show={showSnackBarPopup} message={"Link is updated successfully."} onClose={()=>setShowSnackBarPopup(false)}/> */}
        </DialogContent>

        <Dialog open={openDeleteDialog}>
          <div className="workspace-remove-modal" style={{ height: 'auto' }}>
            <div className="workspace-remove-modalContent-close" style={{ visibility: 'hidden' }}>
              <Tooltip
                title="Close"
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '12px',
                    },
                  },
                }}
              >
                <CloseIcon
                  sx={{
                    fontSize: 'large',
                    color: '#545454',
                    cursor: 'pointer',
                    '&:hover': {
                      color: 'red',
                    },
                  }}
                />
              </Tooltip>
            </div>

            <div className="workspace-remove-modalContent-p">
              <p
                style={{
                  fontSize: fontSize.medium,
                  color: palette.primary.contrastText,
                }}
              >
                Are you sure you want to delete this dashboard link? It will be permanently deleted.
              </p>
            </div>

            <div className="workspace-modal-buttons">
              <button
                onClick={() => setOpenDeleteDialog(false)}
                className="workspace-modal-cancel"
                style={{ fontSize: fontSize.medium }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (selectedLinkId) {
                    confirmDeleteLink(selectedLinkId);
                  }
                }}
                className="workspace-modal-confirm"
                style={{ fontSize: fontSize.medium }}
              >
                Confirm
              </button>
            </div>
          </div>
        </Dialog>

        <NotificationDialog
          openAlert={openAlert}
          severity={severity}
          testMessage={testMessage}
          onCloseAlert={() => {
            setOpenAlert(false);
            setTestMessage('');
          }}
          sx={{
            '& .MuiDialog-container': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        />
      </Dialog>
      <PopUpSpinner show={loading} />
    </div>
  );
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    token: state.isLogged.accessToken,
    tabState: state.tabState,
  };
};

export default connect(mapStateToProps, null)(SharedLinks);
